/** Fuso da saudação: o horário de Brasília (a mesma referência das datas do produto). */
const TIME_ZONE = 'America/Sao_Paulo';

/**
 * Saudação da home mobile (PRD §11.30; DEC-060) pela hora em São Paulo: bom dia das 5h às 11h59, boa tarde das 12h às
 * 17h59 e boa noite das 18h às 4h59.
 */
export function greetingFor(now: Date): 'Bom dia' | 'Boa tarde' | 'Boa noite' {
  const hour = Number(
    new Intl.DateTimeFormat('pt-BR', { timeZone: TIME_ZONE, hour: '2-digit', hourCycle: 'h23' }).format(now),
  );
  if (hour >= 5 && hour < 12) return 'Bom dia';
  if (hour >= 12 && hour < 18) return 'Boa tarde';
  return 'Boa noite';
}

/** O primeiro nome, para a saudação. */
export const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? name;
